import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, a as assertParamExists, C as COLLECTION_FORMATS, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ShippingTypesApi - axios parameter creator
 * @export
 */
const ShippingTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFront: async (options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetAllFront`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Same as M:BizWeb.NC.API.Controllers.ShippingTypesController.GetAllFront but restricts the returned shipping options to those available in the order\'s country (BW-621), region (BW-622) and postal code (BW-623). Reuses the full front enrichment (charges, payment types, images + customer access) and then applies the available-country/region/postal filters so the offered list and the shipping-fee calculation (OTC_BizWebCoreModule) never disagree. Country, region and postal code are independent AND dimensions; an empty available set or an unknown order value on a dimension means \"no restriction on that dimension\". Takes a location-only query (no email) so it can be called before an email exists (e.g. gift-card checkout) — the shipping list never needed an email.
         * @param {ShippingAvailabilityQueryToken} [ShippingAvailabilityQueryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrontByCountry: async (ShippingAvailabilityQueryToken, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetAllFrontByCountry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ShippingAvailabilityQueryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Επιστρέφει μια λίστα από διαθέσιμα ShippingTypeToken αντικείμενα βάση των προϊόντων που υπάρχουν στο καλάθι. Επίσης επιστρέφει και τις αντίστοιχες χρεώσεις για κάθε τύπο αποστολής.
         * @param {CartItemTokenList} [CartItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrontByProducts: async (CartItemTokenList, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetAllFrontByProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CartItemTokenList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayments: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetAllPayments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns every visible shipping type annotated with its availability for a given postal code (admin order-create flow). A type with no postal-code restrictions is available everywhere; a type that has restrictions is supported only when this postal code is mapped. The single \"recommended\" method is the default one if supported, otherwise the cheapest supported one. Built from the generic ShippingTypePostalCodesMap — no per-tenant logic. (Auth roles: Orders,OrderApproval)
         * @param {string} [postcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityByPostcode: async (postcode, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetAvailabilityByPostcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} request_body
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, enrich, options = {}) => {
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('getByIds', 'request_body', request_body);
            const localVarPath = `/v1/ShippingTypes/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPaymentType: async (pid, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/GetByPaymentType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (pid !== undefined) {
                localVarQueryParameter['pid'] = pid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ShippingTypeToken} [ShippingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ShippingTypeToken, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ShippingTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a list of shipping types based on the provided filters. (Auth)
         * @param {ShippingTypeLookupRequest} ShippingTypeLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (ShippingTypeLookupRequest, X_Lookup_Metadata, options = {}) => {
            // verify required parameter 'ShippingTypeLookupRequest' is not null or undefined
            assertParamExists('lookup', 'ShippingTypeLookupRequest', ShippingTypeLookupRequest);
            const localVarPath = `/v1/ShippingTypes/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (X_Lookup_Metadata) {
                let mapped = X_Lookup_Metadata.map(value => (value || ""));
                localVarHeaderParameter['X-Lookup-Metadata'] = mapped.join(COLLECTION_FORMATS["csv"]);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ShippingTypeLookupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {PaymentShippingOptionsToken} [PaymentShippingOptionsToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePaymentsTypes: async (PaymentShippingOptionsToken, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/SavePaymentsTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PaymentShippingOptionsToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ShippingTypeToken} [ShippingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ShippingTypeToken, options = {}) => {
            const localVarPath = `/v1/ShippingTypes/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ShippingTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ShippingTypesApi - functional programming interface
 * @export
 */
const ShippingTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShippingTypesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFront(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFront(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getAllFront']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Same as M:BizWeb.NC.API.Controllers.ShippingTypesController.GetAllFront but restricts the returned shipping options to those available in the order\'s country (BW-621), region (BW-622) and postal code (BW-623). Reuses the full front enrichment (charges, payment types, images + customer access) and then applies the available-country/region/postal filters so the offered list and the shipping-fee calculation (OTC_BizWebCoreModule) never disagree. Country, region and postal code are independent AND dimensions; an empty available set or an unknown order value on a dimension means \"no restriction on that dimension\". Takes a location-only query (no email) so it can be called before an email exists (e.g. gift-card checkout) — the shipping list never needed an email.
         * @param {ShippingAvailabilityQueryToken} [ShippingAvailabilityQueryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFrontByCountry(ShippingAvailabilityQueryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFrontByCountry(ShippingAvailabilityQueryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getAllFrontByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Επιστρέφει μια λίστα από διαθέσιμα ShippingTypeToken αντικείμενα βάση των προϊόντων που υπάρχουν στο καλάθι. Επίσης επιστρέφει και τις αντίστοιχες χρεώσεις για κάθε τύπο αποστολής.
         * @param {CartItemTokenList} [CartItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFrontByProducts(CartItemTokenList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFrontByProducts(CartItemTokenList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getAllFrontByProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPayments(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPayments(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getAllPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns every visible shipping type annotated with its availability for a given postal code (admin order-create flow). A type with no postal-code restrictions is available everywhere; a type that has restrictions is supported only when this postal code is mapped. The single \"recommended\" method is the default one if supported, otherwise the cheapest supported one. Built from the generic ShippingTypePostalCodesMap — no per-tenant logic. (Auth roles: Orders,OrderApproval)
         * @param {string} [postcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailabilityByPostcode(postcode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailabilityByPostcode(postcode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getAvailabilityByPostcode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} request_body
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPaymentType(pid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPaymentType(pid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.getByPaymentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ShippingTypeToken} [ShippingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ShippingTypeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ShippingTypeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns a list of shipping types based on the provided filters. (Auth)
         * @param {ShippingTypeLookupRequest} ShippingTypeLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(ShippingTypeLookupRequest, X_Lookup_Metadata, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(ShippingTypeLookupRequest, X_Lookup_Metadata, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {PaymentShippingOptionsToken} [PaymentShippingOptionsToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePaymentsTypes(PaymentShippingOptionsToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePaymentsTypes(PaymentShippingOptionsToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.savePaymentsTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ShippingTypeToken} [ShippingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ShippingTypeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ShippingTypeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingTypesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ShippingTypesApi - factory interface
 * @export
 */
const ShippingTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShippingTypesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFront(options) {
            return localVarFp.getAllFront(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Same as M:BizWeb.NC.API.Controllers.ShippingTypesController.GetAllFront but restricts the returned shipping options to those available in the order\'s country (BW-621), region (BW-622) and postal code (BW-623). Reuses the full front enrichment (charges, payment types, images + customer access) and then applies the available-country/region/postal filters so the offered list and the shipping-fee calculation (OTC_BizWebCoreModule) never disagree. Country, region and postal code are independent AND dimensions; an empty available set or an unknown order value on a dimension means \"no restriction on that dimension\". Takes a location-only query (no email) so it can be called before an email exists (e.g. gift-card checkout) — the shipping list never needed an email.
         * @param {ShippingAvailabilityQueryToken} [ShippingAvailabilityQueryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrontByCountry(ShippingAvailabilityQueryToken, options) {
            return localVarFp.getAllFrontByCountry(ShippingAvailabilityQueryToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Επιστρέφει μια λίστα από διαθέσιμα ShippingTypeToken αντικείμενα βάση των προϊόντων που υπάρχουν στο καλάθι. Επίσης επιστρέφει και τις αντίστοιχες χρεώσεις για κάθε τύπο αποστολής.
         * @param {CartItemTokenList} [CartItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrontByProducts(CartItemTokenList, options) {
            return localVarFp.getAllFrontByProducts(CartItemTokenList, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayments(id, options) {
            return localVarFp.getAllPayments(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns every visible shipping type annotated with its availability for a given postal code (admin order-create flow). A type with no postal-code restrictions is available everywhere; a type that has restrictions is supported only when this postal code is mapped. The single \"recommended\" method is the default one if supported, otherwise the cheapest supported one. Built from the generic ShippingTypePostalCodesMap — no per-tenant logic. (Auth roles: Orders,OrderApproval)
         * @param {string} [postcode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityByPostcode(postcode, options) {
            return localVarFp.getAvailabilityByPostcode(postcode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} request_body
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, enrich, options) {
            return localVarFp.getByIds(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [pid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPaymentType(pid, options) {
            return localVarFp.getByPaymentType(pid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ShippingTypeToken} [ShippingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ShippingTypeToken, options) {
            return localVarFp.insert(ShippingTypeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of shipping types based on the provided filters. (Auth)
         * @param {ShippingTypeLookupRequest} ShippingTypeLookupRequest
         * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(ShippingTypeLookupRequest, X_Lookup_Metadata, options) {
            return localVarFp.lookup(ShippingTypeLookupRequest, X_Lookup_Metadata, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders,OrderApproval)
         * @param {PaymentShippingOptionsToken} [PaymentShippingOptionsToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePaymentsTypes(PaymentShippingOptionsToken, options) {
            return localVarFp.savePaymentsTypes(PaymentShippingOptionsToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders)
         * @param {ShippingTypeToken} [ShippingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ShippingTypeToken, options) {
            return localVarFp.update(ShippingTypeToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShippingTypesApi - object-oriented interface
 * @export
 * @class ShippingTypesApi
 * @extends {BaseAPI}
 */
class ShippingTypesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getAll(options) {
        return ShippingTypesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getAllFront(options) {
        return ShippingTypesApiFp(this.configuration).getAllFront(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Same as M:BizWeb.NC.API.Controllers.ShippingTypesController.GetAllFront but restricts the returned shipping options to those available in the order\'s country (BW-621), region (BW-622) and postal code (BW-623). Reuses the full front enrichment (charges, payment types, images + customer access) and then applies the available-country/region/postal filters so the offered list and the shipping-fee calculation (OTC_BizWebCoreModule) never disagree. Country, region and postal code are independent AND dimensions; an empty available set or an unknown order value on a dimension means \"no restriction on that dimension\". Takes a location-only query (no email) so it can be called before an email exists (e.g. gift-card checkout) — the shipping list never needed an email.
     * @param {ShippingAvailabilityQueryToken} [ShippingAvailabilityQueryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getAllFrontByCountry(ShippingAvailabilityQueryToken, options) {
        return ShippingTypesApiFp(this.configuration).getAllFrontByCountry(ShippingAvailabilityQueryToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Επιστρέφει μια λίστα από διαθέσιμα ShippingTypeToken αντικείμενα βάση των προϊόντων που υπάρχουν στο καλάθι. Επίσης επιστρέφει και τις αντίστοιχες χρεώσεις για κάθε τύπο αποστολής.
     * @param {CartItemTokenList} [CartItemTokenList]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getAllFrontByProducts(CartItemTokenList, options) {
        return ShippingTypesApiFp(this.configuration).getAllFrontByProducts(CartItemTokenList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getAllPayments(id, options) {
        return ShippingTypesApiFp(this.configuration).getAllPayments(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns every visible shipping type annotated with its availability for a given postal code (admin order-create flow). A type with no postal-code restrictions is available everywhere; a type that has restrictions is supported only when this postal code is mapped. The single \"recommended\" method is the default one if supported, otherwise the cheapest supported one. Built from the generic ShippingTypePostalCodesMap — no per-tenant logic. (Auth roles: Orders,OrderApproval)
     * @param {string} [postcode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getAvailabilityByPostcode(postcode, options) {
        return ShippingTypesApiFp(this.configuration).getAvailabilityByPostcode(postcode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getById(id, options) {
        return ShippingTypesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} request_body
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getByIds(request_body, enrich, options) {
        return ShippingTypesApiFp(this.configuration).getByIds(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [pid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    getByPaymentType(pid, options) {
        return ShippingTypesApiFp(this.configuration).getByPaymentType(pid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {ShippingTypeToken} [ShippingTypeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    insert(ShippingTypeToken, options) {
        return ShippingTypesApiFp(this.configuration).insert(ShippingTypeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of shipping types based on the provided filters. (Auth)
     * @param {ShippingTypeLookupRequest} ShippingTypeLookupRequest
     * @param {Array<string>} [X_Lookup_Metadata] Provides which of the \&#39;total\&#39; or \&#39;offset\&#39; metadata are needed in the response. (Optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    lookup(ShippingTypeLookupRequest, X_Lookup_Metadata, options) {
        return ShippingTypesApiFp(this.configuration).lookup(ShippingTypeLookupRequest, X_Lookup_Metadata, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    remove(id, options) {
        return ShippingTypesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders,OrderApproval)
     * @param {PaymentShippingOptionsToken} [PaymentShippingOptionsToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    savePaymentsTypes(PaymentShippingOptionsToken, options) {
        return ShippingTypesApiFp(this.configuration).savePaymentsTypes(PaymentShippingOptionsToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders)
     * @param {ShippingTypeToken} [ShippingTypeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingTypesApi
     */
    update(ShippingTypeToken, options) {
        return ShippingTypesApiFp(this.configuration).update(ShippingTypeToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ShippingTypesApi, ShippingTypesApiAxiosParamCreator, ShippingTypesApiFactory, ShippingTypesApiFp };
//# sourceMappingURL=shipping-types-api.js.map
